// Ввиду обнаружения изъятия в работе метода toFixed (пример: 0,785 округляет до 2 заков как 0,78)
// Функция была переписана на умножение на число кратое дробной части, округление и деление обратно
// В возвращаемом значении toFixed используется лишь для добавления необходимого количества нулей
const round = (amount, decimals = 2) => {
  const multiplicator = Number(`1${"0".repeat(decimals)}`);
  // const rounded = Number(amount).toFixed(decimals);
  const rounded = Math.round(Number(amount) * multiplicator) / multiplicator;
  return Number.isNaN(rounded) ? "" : rounded.toFixed(decimals);
};

export default round;
